import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

/**
 * * 경고 문구 - 컬러 레드
 * WarningText.tsx 와 같지만 문안이 지정되지 않음
 */

interface IProps {
  children: string | JSX.Element[] | JSX.Element;
}
const WarningTextFrame: React.FC<IProps> = ({ children }) => {
  return (
    <StyledText>
      <p>{children}</p>
    </StyledText>
  );
};

export default WarningTextFrame;
const StyledText = styled.div`
  text-align: center;
  p {
    font-weight: 600;
    color: ${theme.colors.redText};
  }
`;
